import { DIVIDER_TYPE, IMAGE_TYPE, GALLERY_TYPE, GIPHY_TYPE, HTML_TYPE, VIDEO_TYPE, FILE_UPLOAD_TYPE, POLL_TYPE, COLLAPSIBLE_LIST_TYPE, TABLE_TYPE, LINK_PREVIEW_TYPE, APP_EMBED_TYPE, MAP_TYPE, AUDIO_TYPE, LINK_BUTTON_TYPE, ACTION_BUTTON_TYPE, CODE_BLOCK_TYPE, BLOCKQUOTE } from 'wix-rich-content-common';
import { Node_Type } from 'ricos-schema';

const TO_NODE_TYPE = {
  [DIVIDER_TYPE]: [Node_Type.DIVIDER],
  [IMAGE_TYPE]: [Node_Type.IMAGE],
  [GALLERY_TYPE]: [Node_Type.GALLERY],
  [GIPHY_TYPE]: [Node_Type.GIF],
  [HTML_TYPE]: [Node_Type.HTML],
  [VIDEO_TYPE]: [Node_Type.VIDEO],
  [FILE_UPLOAD_TYPE]: [Node_Type.FILE],
  [POLL_TYPE]: [Node_Type.POLL],
  [COLLAPSIBLE_LIST_TYPE]: [Node_Type.COLLAPSIBLE_LIST],
  [TABLE_TYPE]: [Node_Type.TABLE],
  [LINK_PREVIEW_TYPE]: [Node_Type.LINK_PREVIEW, Node_Type.EMBED],
  [APP_EMBED_TYPE]: [Node_Type.APP_EMBED],
  [MAP_TYPE]: [Node_Type.MAP],
  [AUDIO_TYPE]: [Node_Type.AUDIO],
  [LINK_BUTTON_TYPE]: [Node_Type.BUTTON],
  [ACTION_BUTTON_TYPE]: [Node_Type.BUTTON]
};
const TO_DRAFT_TYPE = {
  [Node_Type.DIVIDER]: DIVIDER_TYPE,
  [Node_Type.IMAGE]: IMAGE_TYPE,
  [Node_Type.GALLERY]: GALLERY_TYPE,
  [Node_Type.GIF]: GIPHY_TYPE,
  [Node_Type.HTML]: HTML_TYPE,
  [Node_Type.VIDEO]: VIDEO_TYPE,
  [Node_Type.FILE]: FILE_UPLOAD_TYPE,
  [Node_Type.POLL]: POLL_TYPE,
  [Node_Type.COLLAPSIBLE_LIST]: COLLAPSIBLE_LIST_TYPE,
  [Node_Type.COLLAPSIBLE_ITEM]: COLLAPSIBLE_LIST_TYPE,
  [Node_Type.COLLAPSIBLE_ITEM_BODY]: COLLAPSIBLE_LIST_TYPE,
  [Node_Type.COLLAPSIBLE_ITEM_TITLE]: COLLAPSIBLE_LIST_TYPE,
  [Node_Type.TABLE]: TABLE_TYPE,
  [Node_Type.TABLE_ROW]: TABLE_TYPE,
  [Node_Type.TABLE_CELL]: TABLE_TYPE,
  [Node_Type.EMBED]: LINK_PREVIEW_TYPE,
  [Node_Type.LINK_PREVIEW]: LINK_PREVIEW_TYPE,
  [Node_Type.APP_EMBED]: APP_EMBED_TYPE,
  [Node_Type.MAP]: MAP_TYPE,
  [Node_Type.AUDIO]: AUDIO_TYPE,
  [Node_Type.BUTTON]: LINK_BUTTON_TYPE,
  [Node_Type.CODE_BLOCK]: CODE_BLOCK_TYPE,
  [Node_Type.BLOCKQUOTE]: BLOCKQUOTE
};

export { TO_DRAFT_TYPE, TO_NODE_TYPE };
//# sourceMappingURL=consts.js.map
